export default __webpack_public_path__ + "static/media/github.f330d08b.svg";